import { render, staticRenderFns } from "./scorerecordcheck.vue?vue&type=template&id=1c41d9dc&scoped=true"
import script from "./scorerecordcheck.vue?vue&type=script&lang=js"
export * from "./scorerecordcheck.vue?vue&type=script&lang=js"
import style0 from "./scorerecordcheck.vue?vue&type=style&index=0&id=1c41d9dc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41d9dc",
  null
  
)

export default component.exports